declare global {
    interface Window {
        dataLayer: any[];
    }
}
// Tracks form submissions and pushes events to GTM.
class UniversalFormTracking {
    constructor() {
        this.init();
    }

    init(): void {
        console.log("Universal form tracking script is running");
        this.wrapFormEmbeds();
        this.observeThankYouMessages();
    }
    // Wraps known form embed scripts in a div for tracking.
    // The wrapper div allows us to track the form source and ID.
    private wrapFormEmbeds(): void {
        const knownFormScripts = document.querySelectorAll<HTMLScriptElement>(
            'script[src*="clive.cloud"], script[src*="formstack.com"], script[src*="slate.com"]'
        );

        knownFormScripts.forEach((script, index) => {
            if (!script.closest('.form-embed-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'form-embed-wrapper';
                wrapper.dataset.formSource = `WYSIWYG Script #${index + 1}`;
                wrapper.dataset.formDetected = 'true';
                script.parentNode?.insertBefore(wrapper, script);
                wrapper.appendChild(script);
            }
        });
    }
    // Observes the DOM for thank you messages and pushes events to GTM.
    private observeThankYouMessages(): void {
        // Ensure GTM dataLayer exists
        window.dataLayer = window.dataLayer || [];
        // Create a MutationObserver to watch for added nodes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (
                        node.nodeType === 1 &&
                        /thank\s?you|submission received|we’ll be in touch/i.test((node as HTMLElement).textContent || '') &&
                        !(node as HTMLElement).dataset.tracked
                    ) {
                        const element = node as HTMLElement;
                        element.dataset.tracked = 'true';

                        const wrapper = element.closest('.form-embed-wrapper') || document.querySelector('.form-embed-wrapper');

                        const formSource = wrapper?.getAttribute('data-form-source') || 'unknown';
                        const formId = wrapper?.getAttribute('data-form-block-id') || `wysiwyg-${Date.now()}`;

                        console.log("formSubmit detected:", formSource, formId);

                        window.dataLayer.push({
                            event: "formSubmit",
                            formName: formSource,
                            formId: formId,
                            browser: navigator.userAgent,
                            screenWidth: window.screen.width,
                            screenHeight: window.screen.height
                        });

                    }
                });
            });
        });
        // Observe the body for added nodes
        observer.observe(document.body, { childList: true, subtree: true });
    }
}

export default UniversalFormTracking;
